import Tab from '@/types/Tab'

export default [
	new Tab('failed', {
		to: { name: 'events' },
		name: 'Failed events',
		exact: true,
		value: '/events',
	}),
	new Tab('working', {
		to: { name: 'events-working' },
		name: 'Working events',
		value: '/events/working',
	}),
	new Tab('scheduled', {
		to: { name: 'events-scheduled' },
		name: 'Scheduled events',
		value: '/events/scheduled',
	}),
]
